/**
 * AG Grid 35 warns when `paginationPageSize` is missing from
 * `paginationPageSizeSelector`. The default selector is [20, 50, 100]
 * (warnings #94 and #95). Tables in this repo use 15, 25, 50, 100, and 150.
 *
 * When the page size is not in the selector, add it and sort the list.
 * `false` disables the selector and is left alone. The input options object
 * and any existing selector array are not mutated.
 */

export const DEFAULT_PAGINATION_PAGE_SIZE_SELECTOR = [20, 50, 100];

export function ensurePaginationPageSizeSelector(options) {
  if (!options || typeof options !== "object") return options;

  const pageSize = Number(options.paginationPageSize);
  if (!Number.isFinite(pageSize)) return options;
  if (options.paginationPageSizeSelector === false) return options;

  const source = Array.isArray(options.paginationPageSizeSelector)
    ? options.paginationPageSizeSelector
    : DEFAULT_PAGINATION_PAGE_SIZE_SELECTOR;
  const numeric = source.map(Number).filter(Number.isFinite);
  if (numeric.includes(pageSize)) return options;

  return {
    ...options,
    paginationPageSizeSelector: [...numeric, pageSize].sort((a, b) => a - b),
  };
}
